import React, { useRef, useState } from 'react'
import { Col, Container, Form, Row } from "react-bootstrap"
import loginImg from "../assets/login (1).png"
import bank from "../assets/bank.png"
import cash from "../assets/money.png"
import CustomBtn from '../components/CustomBtn/CustomBtn'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import CustomPDFModal from "../components/CustomPDFModal/CustomPDFModal"
import { loginMethod } from '../hooks/auth'
function Payment() {
  const [statex, setState] = useState('')
  const {gradId}=useParams();
  const {id}=useParams();
  

  const userinfo = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false)
  const [modalState, setModalState] = useState("");
  const [loading, setLoading] = useState(false);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const {expensesArray} = useSelector((state) => state.expenses);
  const gradeId=gradId?gradId:userinfo.auth.userArray.user.student?.grade?.id
  const grade=expensesArray.filter((item)=>item?.grade?.id==gradeId)
  
  const [file, setFile] = useState(null);
  const [signedFile, setSignedFile] = useState(null);
  const inputRef = useRef(null);
  const handleSignedPdf = (file) => {
    setSignedFile(file);
  }
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  const handleUpload = async () => {
    if (!file) {
      alert("Please select an image first!");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    setLoading(true)
    try {
          const formDataa = new FormData();

  if (signedFile) {
    formDataa.append("application_form", signedFile);
  }
  formDataa.append("payment_method", statex === "cash" ? 1 : 2);
  formDataa.append("register_fee_image", file);
if(id){
    formDataa.append("student_id", id);

}
      const res = await axios.post(userinfo?.auth?.userArray?.user?.role == "School Manager" ?"https://nanosoft.space/taarteb/public/api/admin/upload-register-fee-receipt" :"https://nanosoft.space/taarteb/public/api/students/upload-register-fee-receipt", formDataa, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,

        },
      });
      localStorage.setItem("type", "student");
      
//                 dispatch(loginMethod({
//   ...userinfo.auth,            // البيانات القديمة (بما فيها التوكن)
//   user: res.data.data.user,    // تحديث المستخدم فقط
// }));

      setLoading(false)
if(id){
      navigate("/dashboard/students/expenses");

}else{
        navigate("/dashboard/dashboard");

}

    } catch (err) {
      console.error("Upload failed:", err);
      setLoading(false)

    }
  };

  const handleOption = (value) => {
    setModalState(value);
    setShow(true)

    // if(value==="signatureOnline"){
    // handleShow()

    // }else{
    // setShow(true)

    // }
  };
  return (
    <Container fluid >
      {/* <CustomPDFModal
        show={show}
        onHide={() => setShow(false)}
        modalState={modalState}
        onSigned={handleSignedPdf}

      /> */}
      <Row className="px-2">
        <Col md={5} className="px-2">
          <div className=" w-100 d-flex justify-content-center align-items-center login_img_container" style={{ backgroundColor: "#e63967", height: "100vh", borderTopRightRadius: "24px", borderBottomRightRadius: "24px" }}>
            <img src={loginImg} alt="" className="w-75" />
          </div>
        </Col>
        <Col md={7} className="px-2">
          <div className="w-100 d-flex justify-content-center mx-3" style={{ height: "100vh", overflowY: "scroll" }}>
            <div className="login_form_section_container d-flex flex-column pt-3  align-items-center"
              style={{ cursor: "pointer" }}

            >
              <h4 className='fw-bold mb-4 text-center'>{currentLocal.home.Pleasepaytheregistrationformfee}{" "}{grade[0]?.details?.[0]?.price}{" "}{currentLocal.home.currancy}{" "}{grade[0]?.details?.[0]?.name} </h4>
              <h5 className='fw-bold text-center'>{currentLocal.home.Chooseapaymentmethod} </h5 >
              <div className='d-flex'>
                {id&&
                <div
                  className='d-flex flex-column mt-3 align-items-center py-3  px-1 mx-2 justify-content-center'
                  style={{
                    border:statex=="cash"?"1px solid #e63967":"1px solid #dee2e6"
                  }}
                  onClick={() => setState("cash")}
                >
                  <img src={cash} alt="" className="w-25" />

                  <p className='fs-6 text-center'>{currentLocal.home.Cash}</p>
                </div>
}
                <div
                  className='d-flex flex-column mt-3 align-items-center py-3  px-1 '
                     style={{
                    border:statex=="bank"?"1px solid #e63967":"1px solid #dee2e6",
                    cursor: "pointer" 
                  }}
                  onClick={() => setState("bank")}
                >
                  <img src={bank} alt="" className="w-25" />
                  <p className='fs-6 text-center'>
                    {currentLocal.home.bankAccount}
                  </p>
                </div>
              </div>
              {statex == "bank" ?
                <div>
                  <h6 className='mt-3'>{currentLocal.home.Pleasesendtheformfeetomyaccount} </h6>
                  <p className='mb-1 text-center'>0429004961810012</p>
                  <p className='fw-bold text-center'>بنك مسقط</p>
                  <p>{currentLocal.home.Pleasesendthereceipt}</p>
                  <div>

                    {/* Hidden file input */}
                    <input
                      type="file"
                      accept="image/*"
                      ref={inputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />

                    {/* Custom button to trigger file input */}
                    <div
                      style={{ border: "1px dashed #000", height: "150px", justifyContent: "center", alignItems: "center", display: "flex", width: "350px", }}
                      onClick={() => inputRef.current.click()}
                    >
                      {file ?
                        <div>
                          <img
                            src={URL.createObjectURL(file)}
                            alt="preview"
                            style={{ height: "100px", width: "100", }}
                          />
                        </div>
                        :
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="gray" className="bi bi-image" viewBox="0 0 16 16">
                            <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                            <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z" />
                          </svg>    </>
                      }

                    </div>



                  </div>



                </div>
                :
                <>
                  <p className='mt-4'>{currentLocal.home.Pleasesendthereceipt}</p>
                  <div>

                    {/* Hidden file input */}
                    <input
                      type="file"
                      accept="image/*"
                      ref={inputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />

                    {/* Custom button to trigger file input */}
                    <div
                      style={{ border: "1px dashed #000", height: "150px", justifyContent: "center", alignItems: "center", display: "flex", width: "350px", }}
                      onClick={() => inputRef.current.click()}
                    >
                      {file ?
                        <div>
                          <img
                            src={URL.createObjectURL(file)}
                            alt="preview"
                            style={{ height: "150px" }}
                          />
                        </div>
                        :
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="gray" className="bi bi-image" viewBox="0 0 16 16">
                            <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                            <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z" />
                          </svg>
                        </>
                      }

                    </div>



                  </div>
                </>
              }
              {/* {!userinfo?.auth?.userArray?.user?.student?.application_form&&
              <div className='my-2'>
                <div
                  className="form-group checkbox-group"

                >
                  <label
                    style={{ cursor: "pointer" }}

                  >
            {currentLocal.home.Registrationfile} {signedFile&&"("+currentLocal.home.RegistrationfileDone+")"}
                  </label>
                </div>
                <div className="d-flex align-items-center">

                  <Form dir={currentLocal.language === "العربية" && "rtl"}>
                    {['radio'].map((type) => (
                      <div key={`inline-${type}`} className="mb-3">
                        <Form.Check
                          inline
                          reverse={currentLocal.language === "العربيه"}
                          label={<span style={{ cursor: "pointer" }}>{currentLocal.home.signAndResend}</span>}
                          name="group1"
                          type={type}
                          id={`inline-${type}-1`}
                          style={{ cursor: "pointer" }}
                          onChange={() => handleOption("signAndResend")}

                        />
                        <Form.Check
                          inline
                          reverse={currentLocal.language === "العربيه"}
                          label={<span style={{ cursor: "pointer" }}>{currentLocal.home.signatureOnline}</span>}
                          name="group1"
                          type={type}
                          id={`inline-${type}-2`}
                          style={{ cursor: "pointer" }}
                          onChange={() => handleOption("signatureOnline")}


                        />
                      </div>
                    ))}
                  </Form>


                </div>
              </div>
} */}
              <div className='mt-4 w-100 mx-3'>
                <div className='d-flex  justify-content-center align-items-center'>
                  <CustomBtn text={loading ? currentLocal.home.Loading : currentLocal.home.send} disabled={loading} type={"submit"} clickingFunction={handleUpload} />

                </div>
              </div>

              {/* <SignupForm/> */}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default Payment